import useModuleAuth from '../hooks/useModuleAuth';

const normalizeRole = (role) => {
  if (!role) return '';
  const value = String(role).replace(/-/g, '_').toUpperCase();
  return value === 'SUPER_ADMIN' ? 'ADMIN' : value;
};

export default function RoleGuard({ allow = ['ADMIN'], fallback = null, children }) {
  const { role } = useModuleAuth();
  const allowed = allow.map(normalizeRole);
  if (!allowed.includes(normalizeRole(role))) return fallback;
  return children;
}
